import { connect } from 'react-redux';
import { forgotPassword } from 'data/login/login.actions';
import ForgotPasswordContainer from './ForgotPasswordContainer';

const actions = {
  forgotPassword
};

function mapStateToProps(state) {
  return {
    forgotPasswordLoading: state.login.forgotPasswordLoading,
    forgotPasswordSuccess: state.login.forgotPasswordSuccess
  };
}

export default connect(mapStateToProps, actions)(ForgotPasswordContainer);
